import SelectCell from './SelectCellContainer';

export default SelectCell;
